import React, { useMemo } from "react";
import PickerInput, { PickerPropsWithoutOptions } from "../inputs/PickerInput";

interface Props extends PickerPropsWithoutOptions { }

export default function CallSourcePicker({ ...PickerProps }: Props) {

    const values: string[] = ['N/A', 'Automated SMS Response', 'Call', 'Live Chat', 'Support Center Email', 'Video Call'];

    const options = useMemo(() => values.map(c => ({ id: c, label: c })), [values]);

    return <PickerInput label={'Call Source'} options={options} {...PickerProps} />
}